/* Focal supplies slide-show, collection-list, image-with-text and product-list.
   This enhancement handles catalog navigation and motion preferences. */
(() => {
  const mobileMenu=document.querySelector('.cv-mobile-menu');
  if(mobileMenu){
    const groups=[...mobileMenu.querySelectorAll('.cv-mobile-accordion')];
    groups.forEach(group=>group.addEventListener('toggle',()=>{
      group.querySelector('summary').setAttribute('aria-expanded',String(group.open));
      if(group.open)groups.filter(other=>other!==group).forEach(other=>other.open=false);
    }));
    const drawer=mobileMenu.closest('mobile-navigation');
    mobileMenu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>drawer.querySelector('[data-action="close"]').click()));
    new MutationObserver(()=>{
      document.documentElement.classList.toggle('cv-menu-open',drawer.hasAttribute('open'));
      if(matchMedia('(max-width:999px)').matches)requestAnimationFrame(()=>drawer.getAnimations({subtree:true}).forEach(animation=>animation.effect?.updateTiming({duration:matchMedia('(prefers-reduced-motion:reduce)').matches?0:200})));
    }).observe(drawer,{attributes:true,attributeFilter:['open']});
  }
  if (!window.__celoviaCollectionsBound) {
    window.__celoviaCollectionsBound = true;
    const closeMenus = event => {
      document.querySelectorAll('details.cv-catalog-menu[open]').forEach(menu => {
        if (event.type === 'keydown') {
          if (event.key !== 'Escape') return;
          menu.removeAttribute('open');
          menu.querySelector('summary').focus();
        } else if (!menu.contains(event.target)) menu.removeAttribute('open');
      });
    };
    document.addEventListener('click', closeMenus);
    document.addEventListener('focusin', closeMenus);
    document.addEventListener('keydown', closeMenus);
  }
  if (!document.body.classList.contains('cv-seasonal-page')) return;
  if (window.__celoviaSeasonsBound) return;
  window.__celoviaSeasonsBound = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobileLayout = matchMedia('(max-width: 740px)');
  const initCollectionZoom = root => {
    const cards = [...root.querySelectorAll('.cv-season-collage .image-zoom')];
    const reset = except => cards.forEach(card => {
      if (card !== except) card.removeAttribute('data-cv-zoom-active');
    });
    cards.forEach(card => {
      if (card.dataset.zoomBound) return;
      card.dataset.zoomBound = 'true';
      const zoomOnContact = () => {
        if (reduced.matches || document.hidden) return;
        reset(card);
        card.setAttribute('data-cv-zoom-active', '');
      };
      card.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || mobileLayout.matches) zoomOnContact();
      }, { passive: true });
      if (!window.PointerEvent) card.addEventListener('touchstart', zoomOnContact, { passive: true });
      card.addEventListener('keydown', event => { if (event.key === 'Escape') reset(); });
      card.addEventListener('focusout', event => { if (!card.contains(event.relatedTarget)) card.removeAttribute('data-cv-zoom-active'); });
      new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) card.removeAttribute('data-cv-zoom-active');
      }, { threshold: .15 }).observe(card);
    });
    if (!cards.length) return;
    document.addEventListener('pointerdown', event => {
      cards.forEach(card => { if (!card.contains(event.target)) card.removeAttribute('data-cv-zoom-active'); });
    });
    document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); });
    reduced.addEventListener('change', () => { if (reduced.matches) reset(); });
  };
  // The still is always the default. Each hero clip plays only on explicit hover/tap.
  const initHeroMotion = root => {
    const panels = [...root.querySelectorAll('[data-cv-motion-panel]')];
    const stopAll = except => panels.forEach(panel => {
      if (panel !== except) panel.cvStopMotion?.();
    });
    panels.forEach(panel => {
      const video = panel.querySelector('[data-cv-hero-video]');
      if (!video || panel.dataset.motionBound) return;
      panel.dataset.motionBound = 'true';
      const trigger = panel.querySelector('[data-cv-motion-trigger]');
      video.muted = true; video.playsInline = true; video.controls = false;
      video.autoplay = false; video.loop = true;
      if (navigator.connection?.saveData) video.preload = 'metadata';
      let requested = false;
      const stop = () => {
        requested = false;
        panel.removeAttribute('data-motion-active');
        trigger?.setAttribute('aria-pressed', 'false');
        video.pause();
        if (video.readyState) video.currentTime = 0;
      };
      panel.cvStopMotion = stop;
      const play = () => {
        if (reduced.matches || document.hidden || video.error) return false;
        stopAll(panel);
        requested = true;
        video.play().catch(stop);
        return true;
      };
      video.addEventListener('playing', () => {
        if (requested) {
          panel.setAttribute('data-motion-active', '');
          trigger?.setAttribute('aria-pressed', 'true');
        }
        else stop();
      });
      video.addEventListener('error', stop);
      panel.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') play();
      });
      panel.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') stop();
      });
      const startOnContact = event => {
        if (!requested && !event.target.closest('[data-cv-collection-link]')) play();
      };
      panel.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse') startOnContact(event);
      }, { passive: true });
      // Older touch browsers still receive the same light-contact behavior.
      if (!window.PointerEvent) panel.addEventListener('touchstart', event => {
        startOnContact(event);
      }, { passive: true });
      // Scrolling can cancel a touch pointer. Keep the preview until it leaves view.
      // A normal click is also a playback fallback for browsers requiring release.
      panel.addEventListener('click', event => {
        if (!event.target.closest('[data-cv-collection-link]') && !requested) play();
      });
      // Only the separate collection links navigate; touching the image stays here.
      panel.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); requested ? stop() : play(); }
        if (event.key === 'Escape') stop();
      });
      panel.addEventListener('focusout', event => { if (!panel.contains(event.relatedTarget)) stop(); });
      new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) stop();
      }, { threshold: .15 }).observe(panel);
      document.addEventListener('pointerdown', event => { if (!panel.contains(event.target)) stop(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
      reduced.addEventListener('change', () => { if (reduced.matches) stop(); });
    });
  };
  const prepareMotion = root => {
    if (!reduced.matches) return;
    root.querySelectorAll('[reveal-on-scroll], [stagger-apparition], [reveal], [reveal-visibility]').forEach(el => {
      ['reveal-on-scroll','stagger-apparition','reveal','reveal-visibility'].forEach(a => el.removeAttribute(a));
    });
    root.querySelectorAll('slide-show').forEach(el => el.setAttribute('transition-type','fade'));
  };
  const enhanceVideo = video => {
    if (video.dataset.cvBound) return;
    video.dataset.cvBound = 'true';
    video.autoplay = false; video.removeAttribute('autoplay');
    video.controls = false; video.muted = true; video.playsInline = true;
    video.preload = 'none'; video.playbackRate = .75;
    video.parentElement.querySelectorAll('[data-cv-video-toggle]').forEach(button => button.remove());
    video.tabIndex = 0;
    video.setAttribute('role','button');
    let inView = false, userPaused = false;
    const sync = () => {
      video.setAttribute('aria-label', video.paused ? 'Sommerfilm abspielen' : 'Sommerfilm anhalten');
      video.setAttribute('aria-pressed', String(!video.paused));
    };
    const play = () => {
      let changed = false;
      video.querySelectorAll('source[data-src]').forEach(source => {
        if (!source.src) { source.src = source.dataset.src; changed = true; }
      });
      if (changed) video.load();
      video.play().catch(sync);
    };
    const update = () => {
      if (inView && !document.hidden && !userPaused && !reduced.matches && !navigator.connection?.saveData) play();
      else video.pause();
    };
    const toggle = () => { userPaused = !video.paused; if(userPaused) video.pause(); else play(); };
    video.addEventListener('click', toggle);
    video.addEventListener('keydown', event => {
      if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); toggle(); }
    });
    video.addEventListener('loadedmetadata', () => { video.playbackRate = .75; });
    video.addEventListener('playing', sync); video.addEventListener('pause', sync);
    const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; update(); }, {threshold:.25});
    observer.observe(video);
    document.addEventListener('visibilitychange', update);
    reduced.addEventListener('change', update);
    sync();
  };
  const init = root => {
    prepareMotion(root);
    initCollectionZoom(root);
    initHeroMotion(root);
    root.querySelectorAll('[data-cv-video], .cv-seasonal-page #main video:not([data-cv-hero-video]):not([data-cv-campaign-video])').forEach(enhanceVideo);
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      prepareMotion(document);
      document.getAnimations().forEach(animation => {
        if (animation.effect?.target?.closest('.cv-seasonal-page')) {
          if (animation.effect.getTiming().iterations === Infinity) animation.cancel();
          else animation.finish();
        }
      });
    }
  });
})();
